import { Table } from 'antd';

interface Props {
  data?: {
    login: string;
    password: string;
  };
}

const InvoiceCreateAuthenticationTable = ({ data }: Props) => {
  return (
    <Table
      dataSource={data ? [data] : []}
      columns={[
        {
          dataIndex: 'login',
          title: 'Login',
        },
        {
          dataIndex: 'password',
          title: 'Senha',
          render: (value) => (value ? '*'.repeat(value?.length) : undefined),
        },
      ]}
      pagination={false}
    />
  );
};

export default InvoiceCreateAuthenticationTable;
